<template>
    <div :class="['introduce-wrapper', isAuthenticed ? 'isAuth' : '']">
        <div class="introduce">
            <div class="header">
                <template v-if="isAuthenticed">
                    <div class="title">一键授权，获取律师专属权益</div>
                    <div class="subTitle">
                        法行宝-百度旗下专业法律服务平台，让律师获取案源更简单
                    </div>
                    <div class="authorize-icons">
                        <div class="lvlin-logo">
                            <span>法行宝</span>
                        </div>
                        <div class="swap-icon"></div>
                        <div class="bjh-logo">
                            <span>百家号</span>
                        </div>
                    </div>
                    <table class="authorize-info" cellspacing="0">
                        <thead>
                            <th>百家号名称</th>
                            <th>百度账号</th>
                            <th>已绑定姓名</th>
                            <th>账号绑定手机</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ bjhUserInfo.bjh_name || "--" }}</td>
                                <td>{{ bjhUserInfo.bd_name || "--" }}</td>
                                <td>{{ bjhUserInfo.owner_name || "--" }}</td>
                                <td>{{ bjhUserInfo.mobile_number || "--" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <template v-else>
                    <div class="title">完成法行宝律师认证，获取专属权益</div>
                    <div class="subTitle">
                        法行宝-百度旗下专业法律服务平台，让律师获取案源更简单
                    </div>
                </template>
            </div>
            <free-vip-content/>
            <div class="footer">
                <template v-if="isAuthenticed">
                    <div class="agreement">
                        <veui-checkbox
                            v-model="isAgree" :false-value="null"
                        >我已阅读并知晓
                        </veui-checkbox>
                        <span
                            class="href" @click.stop="goto('serve')"
                        >《律师入驻服务条款》</span>
                        <span
                            class="href" @click.stop="goto('agree')"
                        >《信息真实承诺书》</span>
                        <span
                            class="href" @click.stop="goto('phone')"
                        >《联系方式授权协议》</span>
                    </div>
                    <veui-button
                        :class="['footer-button', !isAgree ? 'disabled' : '']"
                        ui="primary l"
                        :loading="isSubmitting"
                        @click="handleFooterBtnClick"
                    >一键开通法行宝账号</veui-button>
                </template>
                <template v-else>
                    <veui-button
                        class="footer-button"
                        ui="primary l"
                        :loading="isSubmitting"
                        @click="handleFooterBtnClick"
                    >一键开通法行宝账号，免费体验会员</veui-button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file Introduce.vue
 * @desc 第三方引入页
 * @author xingminghua
 */
import {Button, Checkbox} from 'veui';
import {mapState} from 'vuex';
import FreeVipContent from '@/components/vip/free-vip-content';
import {withBase} from '@/utils/basePath';

const url = {
    bjhInfo: '/bp/api/bjhauthentication/info',
    bjhToLvlin: '/bp/api/bjh/bjhtolvlin'
};

export default {
    name: 'Introduce',
    components: {
        'veui-button': Button,
        'veui-checkbox': Checkbox,
        'free-vip-content': FreeVipContent
    },
    data() {
        return {
            isAuthenticed: false,
            bjhUserInfo: {
                bjh_name: '',
                bd_name: '',
                owner_name: '',
                mobile_number: ''
            },
            // 是否有百家号信息
            hasBjh: null,
            isAgree: false,
            isSubmitting: false
        };
    },
    computed: {
        ...mapState({
            isLogin: state => state?.Menu?.isLogin,
            userInfoNew: state => state?.lawStore?.userInfoNew,
            bjhInfo: state => state?.lawStore?.bjhInfo
        })
    },
    watch: {
        userInfoNew(newVal) {
            newVal && this.checkStatus();
        },
        hasBjh() {
            this.checkStatus();
        }
    },
    mounted() {
        if (+this.isLogin === 1) {
            this.getBjhInfo();
        }
        else {
            this.$router.push({
                name: 'login'
            });
        }
    },
    methods: {
        getBjhInfo() {
            this.$http.get(url.bjhInfo).then(res => {
                if (res.data && +res?.code === 0) {
                    const {
                        is_auth = 0,
                        bjh_name,
                        bd_name,
                        owner_name,
                        mobile_number
                    } = res.data;
                    this.hasBjh = true;
                    this.bjhUserInfo = {
                        bjh_name,
                        bd_name,
                        owner_name,
                        mobile_number
                    };
                    this.isAuthenticed = is_auth;
                    this.$wywLog.send({
                        serverId: 16881,
                        area: 'pv',
                        action: 'pv',
                        isAuth: is_auth
                    });
                }
                else {
                    this.hasBjh = false;
                }
            });
        },
        // 检查入驻状态进行跳转
        checkStatus() {
            const {userInfoNew, hasBjh} = this;
            if (Object.keys(userInfoNew).length && hasBjh !== null) {
                // 有律师信息，跳首页
                if (+userInfoNew.user_role !== -1) {
                    this.$Message.info('您已有法行宝账号~');
                    this.$router.push({
                        name: 'lawinfo'
                    });
                    return;
                }
                // 百家号没信息，跳正常入驻渠道
                if (!hasBjh) {
                    this.$router.push({
                        name: 'filldata',
                        query: {
                            fr: this.$wywLog?.getAllKey().originFr || ''
                        }
                    });
                    return;
                }
            }
        },
        // 阅读协议
        goto(type) {
            if (type === 'serve') {
                window.open(
                    'https://lvlin-fe-saas.cdn.bcebos.com/lawyer_rule.pdf'
                );
            }
            else if (type === 'agree') {
                window.open(
                    'https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/160705507337529aaa5c.pdf'
                );
            }
            else if (type === 'phone') {
                window.open(
                    'https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/phone_apply_rule.pdf'
                );
            }
        },
        handleFooterBtnClick() {
            // 未勾选协议
            if (this.isAuthenticed && !this.isAgree) {
                this.$Message.info('请先阅读并勾选相关服务协议~ ');
                return;
            }
            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            this.$wywLog.send({
                serverId: 16881,
                area: 'btn-click',
                action: 'click',
                isAuth: this.isAuthenticed
            });
            let fr = this.$route?.query?.fr || '';
            this.$http
                .post(url.bjhToLvlin)
                .then(res => {
                    // 入驻成功或已有账号
                    if (+res?.code === 0 || +res?.code === 5012) {
                        this.$wywLog.send({
                            serverId: 16881,
                            area: 'btn-click-success',
                            action: 'click',
                            isAuth: this.isAuthenticed
                        });
                        setTimeout(() => {
                            window.location.href = withBase(`/${
                                this.isAuthenticed
                                    ? `lawinfo?fr=${fr}`
                                    : `material?isEdit=edit&editAnchor=authentice_title&fr=${fr}`
                            }`);
                        }, 500);
                    }
                    else {
                        this.$normalizeResponseError(res);
                    }
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
// TODO: 放全局
/deep/ .veui-button[ui~="primary"] {
    background-color: #0055ff;
}
/deep/ .veui-button[ui~="primary"].disabled {
    background-color: #7388e1 !important;
    cursor: not-allowed !important;
}
.introduce-wrapper {
    .introduce {
        width: 1128px;
        margin: 18px auto auto;
        padding: 30px 30px 78px;
        background: #ffffff;
        box-shadow: 0px 6px 14px 0px rgba(227, 233, 237, 0.35);
        border-radius: 8px;
    }
    &.isAuth .introduce {
        padding-bottom: 130px;
    }

    .header {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 32px;
        .title {
            font-family: PingFangSC-Medium;
            font-size: 28px;
            color: #1f1f1f;
            line-height: 28px;
            font-weight: 700;
        }
        .subTitle {
            margin-top: 20px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #858585;
            text-align: center;
            line-height: 14px;
            font-weight: 400;
        }
        .authorize-icons {
            margin-top: 36px;
            display: flex;
            align-items: center;
            padding-bottom: 28px;

            .lvlin-logo,
            .bjh-logo,
            .swap-icon {
                background-repeat: no-repeat;
                background-position: center;
            }

            .lvlin-logo,
            .bjh-logo {
                width: 70px;
                height: 70px;
                background-size: 42px 42px;
                border: 1px solid rgba(244, 245, 248, 1);
                border-radius: 18px;
                position: relative;
                span {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, 28px);
                    width: max-content;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #1f1f1f;
                    line-height: 14px;
                    font-weight: 400;
                }
            }
            .lvlin-logo {
                background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/introduce-bjh/lvlin-logo.png);
            }
            .bjh-logo {
                background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/introduce-bjh/bjh-logo.png);
            }
            .swap-icon {
                width: 27px;
                height: 22px;
                background-size: 100%;
                background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/introduce-bjh/swap-icon.png);
                margin: 0 46px;
            }
        }
        .authorize-info {
            width: 100%;
            margin-top: 33px;
            border: 1px solid rgba(229, 229, 229, 1);
            border-radius: 8px;
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #1f1f1f;
            line-height: 16px;
            font-weight: 700;
            thead {
                background: rgba(247, 247, 247, 0.63);
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #858585;
                line-height: 16px;
                font-weight: 400;
            }
            thead th,
            tbody td {
                padding: 20px 24px;
            }
            thead th:nth-child(1) {
                width: 291px;
            }
            thead th:nth-child(2) {
                width: 276px;
            }
            thead th:nth-child(3) {
                width: 291px;
            }
        }
    }
    .footer {
        background: #fff;
        position: fixed;
        width: 1128px;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        z-index: 1;
        padding: 30px 0;
        display: flex;
        align-items: center;
        flex-direction: column;

        .agreement {
            margin-bottom: 30px;
            .href {
                color: #0055ff;
                cursor: pointer;
            }
        }
        .footer-button {
            width: 460px;
            height: 48px;
            box-shadow: 2px 4px 11px 0 rgba(22, 119, 255, 0.23);
            border-radius: 5px;
        }
    }
}
</style>